import React from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getUserByEmail } from "../lib/api/users";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { authStatus, user } = useAuthenticator((context) => [
    context.authStatus,
    context.user,
  ]);

  const { data: userData, isLoading } = useQuery({
    queryKey: ["user", "stored-email"],
    queryFn: async () => {
      // Get email from stored tokens since we're using manual OAuth
      const email = sessionStorage.getItem("email");
      if (email) {
        return await getUserByEmail(email);
      }
      return null;
    },
    enabled: !!sessionStorage.getItem("email"),
  });

  // Check for stored tokens as fallback (for manual OAuth)
  const hasStoredTokens =
    sessionStorage.getItem("access_token") &&
    sessionStorage.getItem("id_token");

  if (authStatus !== "authenticated" && !hasStoredTokens) {
    console.log(
      "AdminRoute: Not authenticated and no stored tokens, redirecting to home"
    );
    return <Navigate to="/" replace />;
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (userData?.role !== "ADMIN") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
